import { API } from '../utilities/constants';
import { requestWithToken } from '../utilities/request';
import SessionStorageService from '../services/utilities/SessionStorageService';
import AuthProvider, { needTokenUpdate } from '../utilities/authProvider';

const path = '/api/private/';

const documentCodes = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`document_codes/list`),
    params: param,
  });
};

const uploadCompanyDocument = (companyId, file) => {
  const data = new FormData();
  data.append('file_data', file);
  return requestWithToken({
    method: 'POST',
    url: path.concat(`companies/${companyId}/company_documents/temp_files`),
    processData: false,
    dataType: 'file',
    data,
    contentType: false,
  });
};

const uploadWorkerDocument = (companyId, workerId, file) => {
  const data = new FormData();
  data.append('file_data', file);
  return requestWithToken({
    method: 'POST',
    url: `/api/private/ccus/companies/${companyId}/workers/${workerId}/worker_documents/temp_files`,
    processData: false,
    dataType: 'file',
    data,
    contentType: false,
  });
};

const downloadCompanyDocument = async (companyId, fileId) => {
  let token = SessionStorageService.getToken();
  if (needTokenUpdate(token)) {
    token = await AuthProvider.instance.silentTokenUdate();
  }
  const url = `${
    API.endpoint
  }/api/private/companies/${companyId}/company_documents/${fileId}/file`;
  const queryParams = `?document_token=${token}`;
  const query = `${url}${queryParams}`;
  const response = await requestWithToken(
    {
      method: 'GET',
      url: query,
    },
    false
  );
  if (!response) {
    return;
  } else {
    return query;
  }
};

const downloadWorkerDocument = async (companyId, workerId, fileId) => {
  let token = SessionStorageService.getToken();
  if (needTokenUpdate(token)) {
    token = await AuthProvider.instance.silentTokenUdate();
  }
  const url = `${
    API.endpoint
  }/api/private/ccus/companies/${companyId}/workers/${workerId}/worker_documents/${fileId}/file`;
  const queryParams = `?document_token=${token}`;
  const query = `${url}${queryParams}`;
  const response = await requestWithToken(
    {
      method: 'GET',
      url: query,
    },
    false
  );
  if (!response) {
    return;
  } else {
    return query;
  }
};

export const AttachDocuments = {
  documentCodes,
  uploadCompanyDocument,
  uploadWorkerDocument,
  downloadCompanyDocument,
  downloadWorkerDocument,
};

export default AttachDocuments;



// WEBPACK FOOTER //
// ./src/services/AttachDocuments.js